import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useRopeTypeContext } from 'src/contexts/rope-type.context';
import { IRopeTypeSize, IRopeTypeForm } from 'src/models/rope-type.model';
import { actionTypes } from 'src/ducks/rope-type.duck';
import { getRopeTypeStatus } from 'src/selectors/rope-type.selector';
import RopeSizeConductorForm from '../rope-size-conductor-form/rope-size-conductor-form.component';
import style from '../rope-size-conductor-list/rope-size-conductor-list.module.scss';

const RopeSizeConductorAdd: React.FC = () => {
  const { state, actions } = useRopeTypeContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IRopeTypeSize> = {
    ropeType: '',
    ropeId: 0,
  };

  const addStatus = getRopeTypeStatus(state, actionTypes.ROPE_TYPE_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: IRopeTypeForm = {
        ropeType: data.ropeType,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_ROPE_ADD_SUCCESS,
            formData.ropeType ? formData.ropeType : data.ropeType
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_ROPE_CONDUCTOR}
      content={
        <div className={style.content}>
          <RopeSizeConductorForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default RopeSizeConductorAdd;
